(() => {
  angular
    .module('gm.common.controllers')
    .controller('SlideAppNavController', SlideAppNavController);

  function SlideAppNavController(
    $scope,
    $log,
    GmyFeatures,
    GmySlideNavigation,
    GmyVaults,
  ) {
    'ngInject';

    const vm = this;

    vm.scrollToProfile = scrollToProfile;

    function activate() {
      GmyFeatures.checkEnabledAndCountry('sendPayment')
        .then((enabled) => { $scope.sendPaymentEnabled = enabled; });

      GmyFeatures.checkEnabledAndCountry('sendInvoice')
        .then((enabled) => { $scope.sendInvoiceEnabled = enabled; });

      $scope.$on('$locationChangeSuccess', () => {
        GmySlideNavigation.close();
      });

      GmyVaults.getVaultsAndSummary()
        .then(({ vaultsSummary: { sum } }) => {
          $scope.hasVaultsBalance = sum > 0;
        })
        .catch((error) => {
          $log.debug(error);
        });
    }

    function scrollToProfile() {
      const profileSettings = angular.element('#profile-and-settings');
      angular.element('.app-slide-nav--left')
      .find('.app-slide-nav__container')
      .scrollToElementAnimated(profileSettings);
    }

    activate();
  }
})();
